import { render, staticRenderFns } from "./DetalhesViagem.vue?vue&type=template&id=d87aa610&scoped=true&"
import script from "./DetalhesViagem.vue?vue&type=script&lang=js&"
export * from "./DetalhesViagem.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesViagem.vue?vue&type=style&index=0&id=d87aa610&prod&scoped=true&lang=css&"
import style1 from "./DetalhesViagem.vue?vue&type=style&index=1&id=d87aa610&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87aa610",
  null
  
)

export default component.exports